<template>
	<b-modal ref="modal" hide-footer>
		<template v-slot:modal-title>
			{{ $t('invoice.supplier_article_accounts_title') }}
		</template>

		<p class="text-muted">{{ $t('invoice.supplier_article_accounts_intro') }}</p>

		<LoadingSpinner v-if="!loaded" />

		<form v-else @submit.prevent="save">
			<!-- Un compte n'existe que dans sa comptabilité : l'article en retient un par comptabilité,
			     celui de l'entité facturée est proposé à la ventilation. -->
			<div v-for="plan in plans" :key="plan.accountingplan_id" class="form-group">
				<label>{{ plan.accountingplan_label }}</label>
				<e-select
					v-model="plan.account"
					track-by="id"
					label="name"
					:options="plan.options"
					:searchable="true"
					:show-labels="false"
					:allow-empty="true"
					:placeholder="$t('compta.search_accounting_account')"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>

			<div class="text-center">
				<button type="submit" class="btn btn-primary" :disabled="processing">
					<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
					{{ $t('global.enregistrer') }}
				</button>
			</div>
		</form>
	</b-modal>
</template>

<script type="text/javascript">
	import Accounting from "@/mixins/Accounting.js"
	import Invoice from "@/mixins/Invoice.js"

	export default {
		name: "ArticleAccountModal",
		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
		},
		mixins: [Accounting, Invoice],
		data() {
			return {
				tiers_id: null,
				isarticles_id: null,
				plans: [],
				loaded: false,
				processing: false
			}
		},
		methods: {
			/**
			 * Ouvre la modale sur les comptes d'achat retenus pour l'article, un par comptabilité. Seuls les
			 * comptes d'achat hors TVA sont proposés, comme à la ventilation.
			 *
			 * @param {Object} article Article du tableau des articles achetés.
			 * @param {Number} tiers_id Fournisseur de l'article.
			 */
			async open(article, tiers_id) {
				this.tiers_id = tiers_id
				this.isarticles_id = article.isarticles_id
				this.plans = []
				this.loaded = false
				this.processing = false
				this.$refs.modal.show()

				this.plans = (await this.loadAccountingPlansWithAccounts()).map(plan => {
					const options = plan.accounting_account
						.filter(account => account.accountingaccount_supplier && account.accountingaccount_vat === null)
						.map(account => ({ id: account.accountingaccount_id, name: account.accountingaccount_full_label }))

					return {
						accountingplan_id: plan.accountingplan_id,
						accountingplan_label: plan.accountingplan_label,
						options,
						account: options.find(option => option.id == article.accounts[plan.accountingplan_id]) || null
					}
				})
				this.loaded = true
			},

			async save() {
				this.processing = true

				const accounts = this.plans.map(plan => ({
					accountingplan: plan.accountingplan_id,
					accountingaccount: plan.account ? plan.account.id : null
				}))

				if(await this.setTiersSupplierArticleAccounts(this.tiers_id, this.isarticles_id, accounts)) {
					this.$refs.modal.hide()
					this.$emit('updated')
				}

				this.processing = false
			}
		}
	}
</script>
